export default __webpack_public_path__ + "static/media/Bheem-Pul.97a5471a.jpg";